module.exports = __webpack_public_path__ + "a4d1cb7e1f520390dbfd970d374499f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/kavychki.svg
// module id = 1099
// module chunks = 0